import { Chip, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import { BookmarkTypes, IBookmarkCompany } from 'src/model/bookmark';

import IconFeather from 'src/components/common/Icon';
import { Briefcase, Info, MapPin } from 'react-feather';
import { UnknownText } from 'src/utils/constants/config';
import FlagCountry from 'src/components/common/FlagCountry';
import { convertToStartCase, getColorCompanyStatus } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { useTranslation } from 'react-i18next';
import BookmarkCardLayout from 'src/features/Bookmark/Common/BookmarkCardLayout';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useNavigate } from 'react-router-dom';

interface ICompanyBookmarkProps {
  dataBookmark: IBookmarkCompany;
}

const CompanyBookmarkCard = ({ dataBookmark }: ICompanyBookmarkProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickBookmark = () => {
    navigate(AuthRouteKeys.CompanyDetail.replace(':id?', dataBookmark?.data_uuid || ''));
  };
  
  const renderInformationAvailable = () => {
    const information_available: string[] = [];

    if (dataBookmark.is_social_media) {
      information_available.push(t('company_profile.available_info.social'));
    }
    if (dataBookmark.is_stock) {
      information_available.push(t('company_profile.available_info.stock'));
    }
    // if (data.is_websites) {
    //   information_available.push(t('company_profile.available_info.website'));
    // }
    // if (data.is_contacts) {
    //   information_available.push(t('company_profile.available_info.contact'));
    // }
    if (isEmpty(information_available))
      return <Chip size="small" color="default" label={t('company_profile.available_info.empty_text')} />;

    return getArrayDefault(information_available).map((info) => (
      <Chip key={info} size="small" color="default" label={convertToStartCase(info)} />
    ));
  };

  return (
    <BookmarkCardLayout bookmarkType={BookmarkTypes.Company} data={dataBookmark}>
      <Stack direction={'column'} gap={1} onClick={handleClickBookmark}>
        <Typography color={theme.palette.primary.main} variant="subtitle1">
          {dataBookmark.name || UnknownText}
        </Typography>

        <Stack direction={'row'} gap={2}>
          <Stack alignItems={'center'} spacing={1} direction="row">
            <FlagCountry width={20} code={dataBookmark.country_code} />
            <Typography color={'text.secondary'} variant="caption">
              {dataBookmark.country_code || UnknownText}
            </Typography>
          </Stack>

          <Typography display={'flex'} gap={1} color={'text.secondary'} variant="caption" alignItems="center">
            <IconFeather muiProps={{ fontSize: 'small' }} icon={<Briefcase />} />
            {dataBookmark.registration_number || UnknownText}
            <Chip
              label={dataBookmark?.status ?? UnknownText}
              size="small"
              color={getColorCompanyStatus(dataBookmark?.status_code ?? 0)}
            />
          </Typography>
        </Stack>

        <Typography display={'flex'} gap={1} color={'text.secondary'} variant="caption">
          <IconFeather muiProps={{ fontSize: 'small' }} icon={<MapPin />} />
          {dataBookmark.full_address || UnknownText}
        </Typography>

        <Typography alignItems={'center'} display={'flex'} gap={1} color={'text.secondary'} variant="caption">
          <Tooltip placement="top" title={t('company_profile.available_info.tooltip')}>
            <Stack justifyContent="center" alignItems="center">
              <IconFeather muiProps={{ fontSize: 'small' }} icon={<Info />} />
            </Stack>
          </Tooltip>
          {renderInformationAvailable()}
        </Typography>
      </Stack>
    </BookmarkCardLayout>
  );
};
export default CompanyBookmarkCard;
